import '@lottiefiles/lottie-player';
import AOS from 'aos';
import 'aos/dist/aos.css';

window.addEventListener('load', function() { 
    AOS.init({
        offset: 120, // offset (in px) from the original trigger point
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 500, // values from 0 to 3000, with step 50ms
        once: true, // whether animation should happen only once - while scrolling down
        disable: false,
    });

    document.querySelectorAll('.timeline img.lazyload')
    .forEach((img) =>
        img.addEventListener('load', () =>
            AOS.refresh()
        )
    );

    document.querySelector('.loader').classList.remove("loading");
});

const lottiePlayers = document.querySelectorAll('.lottie-player');
window.addEventListener('load', function (event) {
    lottiePlayers.forEach((player) => {
        if (isInViewport(player, 400)) {
            //console.log('LOAD PLAYING: ' + player.src);
            player.play();
        }
    });
});

window.addEventListener('scroll', function (event) {
    lottiePlayers.forEach((player) => {
        if (isInViewport(player, 400)) {
            //console.log('SCROLL PLAYING: ' + player.src);
            player.play();
        }
    });
}, false);

var isInViewport = function (elem, offset) {
    let bounding = elem.getBoundingClientRect();
    return (
        bounding.top <= (window.innerHeight || document.documentElement.clientHeight)-offset
    );
};